import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../locales/en/translation.json';
import translationES from '../locales/es/translation.json';
import translationPT from '../locales/pt-br/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  },
  pt: {
    translation: translationPT
  }
};

i18next.use(LanguageDetector).init({
  detection: {
    order: ['navigator', 'querystring', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain']
  },
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false
  },
  keySeparator: false,
  resources
});

export const globalTranslations = {
  Select: {
    filterOptions: i18next.t('filterOptions'),
    placeholder: 'Select an option',
    noFilteredItemsDefaultMessage: 'No options found'
  }
};

export default i18next;
